export const blockIconsActionShoppingCart = (
	<span className='material-symbols-outlined'>shopping_cart</span>
);
